import { useMemo, useState } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import axios from 'axios';
import { useAsyncEffect } from '@hilma/tools';
import { Localize, useTransform } from '@hilma/netina2all';

import { RecommendersResponse } from '../../types';
import { Slider } from '../../components';
import { shuffle } from '../../functions';
import { useI18n } from '../../hooks';

import Recommender from './Recommender';

const Recommenders: React.FC = () => {
    const [recommenders, setRecommenders] = useState<Localize<RecommendersResponse>[] | null>(null);
    const [error, setError] = useState(false);

    const isVeryBigScreen = useMediaQuery('(min-width: 1100px)');
    const isBigScreen = useMediaQuery('(min-width: 700px)');

    const errText = useI18n(i18n => i18n.errText);

    const translatedRecommenders = useTransform<RecommendersResponse>(recommenders);

    const itemsToShow = useMemo(() => isVeryBigScreen ? 4 : isBigScreen ? 3 : 2, [isVeryBigScreen, isBigScreen]);

    useAsyncEffect(async () => {
        try {
            const response = await axios.get('/api/recommender/get-recommenders');
            setRecommenders(shuffle(response.data));
        } catch (error) {
            console.error(error);
            setError(true);
        }
    }, []);

    if (translatedRecommenders?.length === 0) return null;

    return (
        <div id='recommenders-container'>
            {error && (
                <div>
                    <h2 className='theme-color-text'>{errText.generalSystem}</h2>
                </div>
            )}
            {translatedRecommenders && (
                <Slider
                    width='80vw'
                    itemsToShow={itemsToShow}
                    items={translatedRecommenders.map((recommender, index) => (
                        <Recommender key={index} recommender={recommender} />
                    ))}
                />
            )}
        </div>
    );
}

export default Recommenders;